module.exports = __webpack_public_path__ + "assets/img/block-hover-8c80f148.png";